import {
  containerFluid,
  defaultFont,
//primaryColor,
  defaultBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  grayColor,
//ts_main
} from "assets/jss/material-dashboard-pro-react.jsx";

const headerStyle = theme => ({
  GridContainerLocal:{
    margin  : "0px",
    width   : "calc(100%)",
    zIndex  : "10000",
  },
  GridItemLocal:{
    padding : "0px !important",
    margin  : "0px !important",
    height  : "80px",//"50px",
  },
  AdminNavLink:{
    padding          : "0px !important",
    margin           : "4px !important",
  //fontSize         : "0.75rem",
    fontSize         : "12px",// "12px",
    fontFamily       : '"Roboto"',
    fontWeight       : "500",
    color            : "#FFFFFF",
    textAlign        : "center",
    "vertical-align" : "middle",
    "&:hover"        : { color : "#FFFFFF"},
    "&:focus"        : { color : "#FFDD00", background: "#transparent"},
  },
  langbutton:{
    display         : 'inline-block',
    boxShadow       : "none",
    padding         : 0,
    minHeight       : 0,
    minWidth        : 0,
    marginTop       : 0,//2
    marginBottom    : 0,
    fontSize        : "12px",
    fontFamily      : '"Roboto"',
    fontWeight      : "500",
    textTransform   : 'none',
    color           : "#FFDD00",
    backgroundColor : "transparent !important",
    "&:hover"       : { color : "#FFDD00 !important", backgroundColor: "#transparent !important"},
    "&:focus"       : { color : "#FFDD00 !important", backgroundColor: "#transparent !important"},
  },
  serviceshelpbutton:{
    display         : 'inline-block',
    boxShadow       : "none",
    padding         : 0,
    minHeight       : 0,
    minWidth        : 0,
    marginTop       : 0,//2
    marginBottom    : 0,
    fontSize        : "12px",
    fontFamily      : '"Roboto"',
    fontWeight      : "500",
    textTransform   : 'none',
    color           : "#FFFFFF",
    backgroundColor : "transparent !important",
    "&:hover"       : { color : "#FFFFFF !important", backgroundColor: "#transparent !important"},
    "&:focus"       : { color : "#FFFFFF !important", backgroundColor: "#transparent !important"},
  },
  leftLogoStyle: {
    "& img": {
      marginTop   : "5px",
      marginLeft  : "10px",
      padding     : "0px",
    },
  },
  leftLogoStyleMobile: {
    "& img": {
      marginTop   : "13px",
      marginLeft  : "5px",
      padding     : "0px",
    },
  },
  rightLogoStyle: {
    "& img": {
      margin      : "0px",
      padding     : "0px",
    },
  },
  rightLogoStyleMobile: {
    "& img": {
      "max-width"  : "100%",
      "max-height" : "100%",
      margin       : "0px",
      padding      : "0px",
    },
  },
  appBar: {
    backgroundColor : "transparent",
    boxShadow       : "none",
    borderBottom    : "0",
    position        : "absolute",
    width           : "100%",
    zIndex          : "11029",
    color           : grayColor[6],
    border          : "0",
    borderRadius    : "3px",
  //marginBottom    : "0",
    margin          : "0 !important",
    padding         : "0 !important",
    transition      : "all 150ms ease 0s",
    minHeight       : "50px",
  //minHeight       : "80px",
    display         : "block",
  },
  container: {
    ...containerFluid,
  //minHeight       : "50px",
    minHeight       : "80px",
    margin          : "0 !important",
    padding         : "0 !important",
  },
  drawer:{
    zIndex              : "11028",
  },
  fullList:{
    zIndex              : "11029",
  },
  listItemText: {
    marginTop        : 0,
    marginBottom     : 0,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "100",
    color            : "#8D9A9E",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  ListItemIcon:{
    color: '#ffffff',
  },
  flex: {
    flex: 1
  },
  title: {
    ...defaultFont,
    lineHeight: "30px",
    fontSize: "18px",
    borderRadius: "3px",
    textTransform: "none",
    color: "inherit",
    paddingTop: "0.625rem",
    paddingBottom: "0.625rem",
    margin: "0 !important",
    "&:hover,&:focus": {
      background: "transparent"
    }
  },
  primary: {
  //backgroundColor : primaryColor[0],
    backgroundColor : "#303030",
    color           : whiteColor,
    ...defaultBoxShadow
  },
  info: {
    backgroundColor: infoColor[0],
    color: whiteColor,
    ...defaultBoxShadow
  },
  success: {
    backgroundColor: successColor[0],
    color: whiteColor,
    ...defaultBoxShadow
  },
  warning: {
    backgroundColor: warningColor[0],
    color: whiteColor,
    ...defaultBoxShadow
  },
  danger: {
    backgroundColor: dangerColor[0],
    color: whiteColor,
    ...defaultBoxShadow
  },
  TS_Main: {
  //backgroundColor: ts_main[0],
    backgroundColor: "#5F5F5F",
    color: whiteColor,
    //...defaultBoxShadow          //menis shadow skia
  },
  // sidebarMinimize: {
  //   float: "left",
  //   padding: "0 0 0 15px",
  //   display: "block",
  //   color: grayColor[6]
  // },
  // sidebarMinimizeRTL: {
  //   padding: "0 15px 0 0 !important"
  // },
  // sidebarMiniIcon: {
  //   width: "20px",
  //   height: "17px"
  // }

  link2help:{
    display         : 'inline-block',
    boxShadow       : "none",
    paddingLeft     : 2,
    paddingRight    : 5,
    minHeight       : 0,
    minWidth        : 0,
    marginTop       : 0,//2
    marginBottom    : 0,
    fontSize        : "12px",
    fontFamily      : '"Roboto"',
    fontWeight      : "500",
    textTransform   : 'none',
    color           : "#FFFFFF",
    backgroundColor : "transparent !important",
    "&:hover"       : { color : "#FFFFFF !important", backgroundColor: "#transparent !important"},
    "&:focus"       : { color : "#FFFFFF !important", backgroundColor: "#transparent !important"},
  },

  menuButtonClass: {
    textTransform    : "none",
  //color            : "#transparent !important",
    backgroundColor  : "#5F5F5F !important",
    boxShadow        : "none",
  //width            : "100%",
    'border-radius'  : "0px",
    'border'         : "0px",
    "&:hover"        : { background: "#5F5F5F !important"},
    "&:focus"        : { background: "#5F5F5F !important"},
  },
  menuButtonClassY: {
    position         : "absolute",
    right            : "0px",
    top              : "15px",
    textTransform    : "none",
    color            : "#000000 !important",
    backgroundColor  : "transparent !important",
    boxShadow        : "none !important",
  //width            : "100%",
    'border-radius'  : "0px",
    'border'         : "0px",
    "&:hover"        : { background: "transparent !important"},
    "&:focus"        : { background: "transparent !important"},
  },
  homeButton: {
    marginTop       : 0,
    marginBottom    : 0,
  },
});

export default headerStyle;
